import React, { FunctionComponent, useCallback, useState } from 'react';
import Box from '@material-ui/core/Box';
import Loader from '../../../common/components/presentation/Loader';
import ModalWithHeader from '../../../common/components/presentation/ModalWithHeader';
import MyAccountWidget from '../../../common/components/myAccount/MyAccountWidget';
import myAccountContainerStyles from './MyAccountContainerStyles';
import { Button, Typography } from '@material-ui/core';
import dealApi from '../../api/dealApi';
import Translation from '../translation/Translation';

interface IMyAccountContainer {
  isModalOpen: boolean;
  toggleModal: (shouldOpen: boolean) => void;
}

const MyAccountContainer: FunctionComponent<IMyAccountContainer> = ({ isModalOpen, toggleModal }) => {
  const styles = myAccountContainerStyles();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [isDealSaved, setIsDealSaved] = useState<boolean | null>(null);

  const closeModal = useCallback(() => {
    toggleModal(false);
  }, [toggleModal]);

  const onAuth = useCallback(() => {
    setIsLoading(true);
    setIsLoggedIn(true);

    dealApi
      .save()
      .then(() => {
        setIsDealSaved(true);
      })
      .catch(() => {
        setIsDealSaved(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <ModalWithHeader
      open={isModalOpen}
      toggleModal={toggleModal}
      modalProps={{ 'data-test': 'modal:myAccount' }}
      className={styles.myAccountWrapper}
      title={isLoading || isLoggedIn ? '' : <Translation id="spc.my-account.authentication.label" />}
    >
      <Box mx="auto" textAlign="center" maxWidth="70%" mt={4} mb={4}>
        {isDealSaved && (
          <>
            <Typography variant="h5" data-test="text:saveOffer:ok">
              <Translation id="spc.productConfigure.saveOffer.good" />
            </Typography>
            <Typography>
              <Translation id="spc.productConfigure.saveOffer.saved" />
            </Typography>
          </>
        )}

        {isDealSaved === false && (
          <Typography data-test="text:saveOffer:error">
            <Translation id="spc.productConfigure.saveOffer.error" />
          </Typography>
        )}

        {isDealSaved !== null && (
          <Box mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={closeModal}
              data-test="button:saveOffer:ok"
              className={styles.saveOfferButton}
            >
              <Translation id="spc.productConfigure.saveOffer.ok" />
            </Button>
          </Box>
        )}
      </Box>

      <Box>
        {isLoading && <Loader />}

        {!isLoggedIn && (
          <MyAccountWidget
            setLoadingStatus={setIsLoading}
            closeModal={closeModal}
            onAuth={onAuth}
            isTitleDisplayed={false}
          />
        )}
      </Box>
    </ModalWithHeader>
  );
};

export default MyAccountContainer;
